import { render, staticRenderFns } from "./myinfo.vue?vue&type=template&id=b55a54e8&scoped=true&"
import script from "./myinfo.vue?vue&type=script&lang=js&"
export * from "./myinfo.vue?vue&type=script&lang=js&"
import style0 from "./myinfo.vue?vue&type=style&index=0&id=b55a54e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55a54e8",
  null
  
)

export default component.exports